import { render, staticRenderFns } from "./quickChange.vue?vue&type=template&id=4dca1cf4&scoped=true"
import script from "./quickChange.vue?vue&type=script&lang=js"
export * from "./quickChange.vue?vue&type=script&lang=js"
import style0 from "./quickChange.vue?vue&type=style&index=0&id=4dca1cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dca1cf4",
  null
  
)

export default component.exports